import type { ClientPreset } from './types'

export const clientPresets = {
  proxyrequest: {
    id: 'proxyrequest',
    name: 'ProxyRequest',
    displayDomain: 'ProxyRequest.com',
    siteUrl: 'https://proxyrequest.com',
    iconText: 'P',
    assets: { logoUrl: null, faviconUrl: null },
    links: {
      statusUrl: 'https://uptime.proxyrequest.com',
      telegramUrl: 'https://t.me/proxyrequest',
      contactEmail: 'support@proxyrequest.com',
      docsUrl: 'https://proxyrequest.com/docs/',
    },
    integrations: { googleClientId: null, turnstileSiteKey: null },
  },
} as const satisfies Record<string, ClientPreset>
